import { careersPath } from "./paths";

// Shared links are the app's own address (nandosess.ae/careers/...). Chat
// apps can't run this SPA, so CloudFront hands their link-preview crawlers
// to the API's server-rendered preview page for the same path; people get
// the app as usual. See infra/cloudfront/careers-link-preview.js.
export const appUrl = (path) => `${window.location.origin}${process.env.PUBLIC_URL || ""}${path}`;

export const careersShareUrl = (slug) =>
  appUrl(careersPath(slug));

export const whatsappHref = (text, url) =>
  `https://wa.me/?text=${encodeURIComponent(`${text}\n${url}`)}`;

export const linkedinHref = (url) =>
  `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

export const canNativeShare = () =>
  typeof navigator !== "undefined" && typeof navigator.share === "function";
